import { useEffect, useState, useRef, useCallback } from 'react';

import numeral from 'numeral';


export default function useCountDownTimer(milisecondend = 0) {
    const [seconds, setSeconds] = useState(((milisecondend - Date.now()) / 1000));

    const timerInterval = useRef()

    useEffect(() => {

        timerInterval.current = setInterval(() => {

            const currentSeconds = (milisecondend - Date.now()) / 1000;

            setSeconds(currentSeconds);

        }, 1000)

        return () => {
            if (timerInterval.current)
                clearInterval(timerInterval.current);
        }

    }, [milisecondend])


    const stopTimer = useCallback(() => {
        if (timerInterval.current)
            clearInterval(timerInterval.current)
    }, [])

    const startTimer = useCallback(() => {
        if (!timerInterval.current) {
            timerInterval.current = setInterval(() => {
                const currentSeconds = (Date.now() - milisecondend) / 1000;

                setSeconds(currentSeconds);

            }, 1000)
        }
    }, [milisecondend])

    const resetTimer = useCallback(() => {
        setSeconds(0)
    }, [])

    const timerStr = numeral(seconds).format('00:00:00');
    return {
        seconds,
        stopTimer,
        startTimer,
        resetTimer,
        timerStr,
        timerArray: timerStr.split(":")
    }
}
